module.exports = __webpack_public_path__ + "static/media/icon_4.3e2d51f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_imagerecognition/icon_4.svg
// module id = 542
// module chunks = 0